export default {
  vertical: {
    marginBottom: -10,
  },
  completed: {
    marginBottom: -10,
  },
};
